import {Signal, View} from '@lernetz/ts-lib';
import template from './active-tags.component.html';

export class ActiveTags extends View {
    choose: Signal<unknown>;
    constructor() {
        super({template});
        this.choose = new Signal();
    }
}
